import icon from "../../assets/poe-availability.svg";
import type { Property } from "../../types";

export const poeAvailability: Property = {
  id: "poeAvailability",
  title: "poeAvailability.title",
  icon,
};
